import React, { useState } from 'react';

import { CButton } from '@appcues/component-library';

const DebouncedButton = ({ as, waitMs, disabled, onClick, ...buttonProps }) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = event => {
    if (isDisabled) {
      return;
    }

    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, waitMs);
    onClick(event);
  };

  const ButtonComponent = as || CButton;
  return (
    <ButtonComponent
      disabled={isDisabled || disabled}
      onClick={handleClick}
      {...buttonProps}
    />
  );
};
export default DebouncedButton;
